import React from 'react'

// 首先导入Radix颜色 - 浅色主题（顺序很重要）
import '@radix-ui/colors/gray.css'
import '@radix-ui/colors/blue.css'
import '@radix-ui/colors/red.css'
import '@radix-ui/colors/amber.css'
import '@radix-ui/colors/green.css'
import '@radix-ui/colors/purple.css'
import '@radix-ui/colors/violet.css'
import '@radix-ui/colors/indigo.css'
import '@radix-ui/colors/cyan.css'
import '@radix-ui/colors/teal.css'
import '@radix-ui/colors/orange.css'
import '@radix-ui/colors/tomato.css'

// 再导入Radix颜色 - 深色主题
import '@radix-ui/colors/gray-dark.css'
import '@radix-ui/colors/blue-dark.css'
import '@radix-ui/colors/red-dark.css'
import '@radix-ui/colors/amber-dark.css'
import '@radix-ui/colors/green-dark.css'
import '@radix-ui/colors/purple-dark.css'
import '@radix-ui/colors/violet-dark.css'
import '@radix-ui/colors/indigo-dark.css'
import '@radix-ui/colors/cyan-dark.css'
import '@radix-ui/colors/teal-dark.css'
import '@radix-ui/colors/orange-dark.css'
import '@radix-ui/colors/tomato-dark.css'

// 最后导入其他应用资源
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <DndProvider backend={HTML5Backend}>
      <App />
    </DndProvider>
  </React.StrictMode>,
)
